import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import OtpInput from "react-otp-input";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import {
  LoginTopLogoAndText,
  BackLogoIconButton,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  verify_otp,
  forgot_sendotp,
  resendOtp,
} from "../../../store/actions/authAction";
import { OtpValidation } from "../../../store/validation/allValidationFile/authenticationValidation/OtpValidation";
import isEmpty from "../../../store/validation/is-Empty";

export class Otp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile_number: "",
      country_code: "",
      otp: "",
      errors: {},
      loading: false,
      minutes: 10,
      seconds: 0,
    };
  }

  componentDidMount() {
    if (
      !isEmpty(this.props.location.state.formData.mobile_number) !==
      this.state.mobile_number
    ) {
      this.setState({
        mobile_number: this.props.location.state.formData.mobile_number,
        country_code: this.props.location.state.formData.country_code,
      });
    }
    this.myInterval();
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  handleOtpChange = (otp) => {
    this.setState({ otp });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = OtpValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const formData = {
        country_code: this.state.country_code,
        mobile_number: this.state.mobile_number,
        OTP: this.state.otp,
        strategy: "vendor-user",
      };
      this.props.verify_otp(formData, this.props.history);
    }
  };

  onResendOtpSend = (e) => {
    e.preventDefault();
    this.props.clear_all_errors();
    const formData = {
      country_code: this.state.country_code,
      mobile_number: this.state.mobile_number,
      strategy: "vendor-user",
    };
    this.props.resendOtp(formData, this.onSuccessCall);
  };

  onSuccessCall = (e) => {
    clearInterval(this.myInterval);
    this.setState({
      minutes: 10,
      seconds: 0,
    });
    this.myInterval();
  };

  myInterval = (e) => {
    setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
  };

  render() {
    const { otp, errors, loading, minutes, seconds } = this.state;
    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            {/* <BackButtonIcon linkPath="/forgotpassword" /> */}
            <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
              <div className="col-12 display-top-header-mobile">
                <BackLogoIconButton
                  displayHelpImage={true}
                  displayArrow={true}
                  displayBackText="Back"
                  backButtonClicked="/forgotpassword"
                  notDisplaProgressBar={true}
                />
              </div>
              <div className="col-12 loginsignup-section">
                <LoginTopLogoAndText
                  bigText="Enter OTP"
                  smallText={
                    <>
                      We have sent you access code via SMS for mobile number
                      verification and email
                    </>
                  }
                />
              </div>
              <Col className="login-section-margin">
                <Form noValidate onSubmit={this.handleSubmit}>
                  <Col className="send-otp-input-margin d-block">
                    <div className="d-flex align-items-center">
                      <OtpInput
                        inputStyle={"send-otp-input-filed"}
                        onChange={this.handleOtpChange}
                        numInputs={6}
                        separator={<span className="mr-2"></span>}
                        value={otp}
                      />
                    </div>
                    <Form.Text className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 text-muted input-component-bottom mt-2">
                      <div className="f12-400 text-red">
                        {otp.length >= 1 && otp.length <= 5
                          ? "*The OTP you entered is invalid. "
                          : null || errors.code === 412
                          ? "Please enter the correct OTP."
                          : null}
                      </div>
                    </Form.Text>
                  </Col>

                  <div className="col-12 login-bottom-text-blue ">
                    <div>
                      {minutes === 0 && seconds === 0 ? (
                        "00:00"
                      ) : (
                        <div>
                          {minutes === 10 ? minutes : `0${minutes}`}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </div>
                      )}
                    </div>
                    &nbsp;|&nbsp;
                    <button
                      className="resend-button-blue"
                      onClick={this.onResendOtpSend}
                    >
                      Resend OTP
                    </button>
                  </div>

                  <ButtonReusableComponent
                    buttonText="Verify"
                    buttonType="submit"
                    buttonClass={otp.length < 6 ? "login" : "activeLogin"}
                    disabled={otp.length < 6 ? true : false}
                  />
                </Form>
                {/* <BottomTextAndButton
                  textCss="login-bottom-text mt-2 text-center"
                  text="Didn't get the OTP?"
                  linkText="Resend OTP"
                  onClick={this.onResendOtpSend}
                /> */}
              </Col>
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

Otp.propTypes = {
  clear_all_errors: PropTypes.func.isRequired,
  forgot_sendotp: PropTypes.func.isRequired,
  verify_otp: PropTypes.func.isRequired,
  resendOtp: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  verify_otp,
  forgot_sendotp,
  resendOtp,
})(withRouter(Otp));
